(() => {
  if (window.JerseyPersonalizationLoaded) return;
  window.JerseyPersonalizationLoaded = true;

  const widgetSelector = '[data-jersey-personalization]';

  const selectedOptions = (widget) => ({
    name: widget.querySelector('[data-personalization-toggle="name"]').checked,
    number: widget.querySelector('[data-personalization-toggle="number"]').checked
  });

  const setProperty = (input, value, enabled) => {
    input.value = enabled ? value : '';
    input.disabled = !enabled;
  };

  const syncWidget = (widget) => {
    const selected = selectedOptions(widget);
    const nameInput = widget.querySelector('[data-personalization-name]');
    const numberInput = widget.querySelector('[data-personalization-number]');
    const namePanel = widget.querySelector('[data-personalization-panel="name"]');
    const numberPanel = widget.querySelector('[data-personalization-panel="number"]');
    const total = widget.querySelector('[data-personalization-total]');
    const totalPrice = widget.querySelector('[data-personalization-total-price]');
    const checkoutNote = widget.querySelector('[data-personalization-checkout-note]');
    const form = widget.closest('form');

    namePanel.hidden = !selected.name;
    nameInput.disabled = !selected.name;
    nameInput.required = selected.name;
    numberPanel.hidden = !selected.number;
    numberInput.disabled = !selected.number;
    numberInput.required = selected.number;

    const amount = (selected.name ? 49 : 0) + (selected.number ? 29 : 0);
    total.hidden = amount === 0;
    totalPrice.textContent = `${amount} kr`;
    checkoutNote.hidden = amount === 0;
    form?.classList.toggle('has-jersey-personalization', amount > 0);

    if (!selected.name) nameInput.value = '';
    if (!selected.number) numberInput.value = '';
  };

  const initializeWidget = (widget) => {
    if (widget.dataset.initialized === 'true') return;
    widget.dataset.initialized = 'true';

    widget.addEventListener('change', () => syncWidget(widget));
    widget.querySelector('[data-personalization-number]').addEventListener('input', (event) => {
      event.target.value = event.target.value.replace(/\D/g, '').slice(0, 2);
    });
    syncWidget(widget);
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll(widgetSelector).forEach(initializeWidget);
  };

  const collectLineProperties = (formData) => {
    const properties = {};
    for (const [key, rawValue] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
      if (match && value !== '') properties[match[1]] = value;
    }
    return properties;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    const widget = form?.querySelector(widgetSelector);
    if (!form || !widget) return;

    const selected = selectedOptions(widget);
    if (!selected.name && !selected.number) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const nameInput = widget.querySelector('[data-personalization-name]');
    const numberInput = widget.querySelector('[data-personalization-number]');
    const errorBox = widget.querySelector('[data-personalization-error]');
    const name = nameInput.value.trim();
    const number = numberInput.value.trim();

    errorBox.hidden = true;
    errorBox.textContent = '';

    if ((selected.name && !nameInput.reportValidity()) || (selected.number && !numberInput.reportValidity())) {
      return;
    }

    if (form.dataset.personalizationSubmitting === 'true') return;
    form.dataset.personalizationSubmitting = 'true';

    const key = `personalisering-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    const summary = selected.name && selected.number
      ? 'Navn (+49 kr) og nummer (+29 kr)'
      : selected.name
        ? 'Navn (+49 kr)'
        : 'Nummer (+29 kr)';

    setProperty(widget.querySelector('[data-personalization-property-name]'), name, selected.name);
    setProperty(widget.querySelector('[data-personalization-property-number]'), number, selected.number);
    setProperty(widget.querySelector('[data-personalization-property-summary]'), summary, true);
    setProperty(widget.querySelector('[data-personalization-property-key]'), key, true);

    const formData = new FormData(form);
    const mainVariantId = Number(formData.get('id'));
    const quantity = Math.max(1, Number(formData.get('quantity')) || 1);
    const mainProperties = collectLineProperties(formData);
    const addonVariantId = selected.name && selected.number
      ? widget.dataset.bothVariantId
      : selected.name
        ? widget.dataset.nameVariantId
        : widget.dataset.numberVariantId;

    const addonProperties = {
      Drakt: widget.dataset.productTitle,
      Personalisering: summary,
      '_Personalisering ID': key
    };
    if (selected.name) addonProperties['Navn på drakten'] = name;
    if (selected.number) addonProperties.Draktnummer = number;

    const submitButton = form.querySelector('[data-add-to-cart]');
    const originalButtonText = submitButton?.querySelector('[data-add-to-cart-text]')?.textContent;
    if (submitButton) {
      submitButton.disabled = true;
      const buttonText = submitButton.querySelector('[data-add-to-cart-text]');
      if (buttonText) buttonText.textContent = 'Legger til personalisering …';
    }

    try {
      const response = await fetch(widget.dataset.cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: mainVariantId,
              quantity,
              properties: mainProperties
            },
            {
              id: Number(addonVariantId),
              quantity,
              properties: addonProperties
            }
          ]
        })
      });

      if (!response.ok) {
        const result = await response.json().catch(() => ({}));
        throw new Error(result.description || 'Personaliseringen kunne ikke legges i handlekurven.');
      }

      window.location.assign(widget.dataset.cartUrl);
    } catch (error) {
      form.dataset.personalizationSubmitting = 'false';
      errorBox.textContent = error.message || 'Noe gikk galt. Prøv igjen.';
      errorBox.hidden = false;
      if (submitButton) {
        submitButton.disabled = false;
        const buttonText = submitButton.querySelector('[data-add-to-cart-text]');
        if (buttonText && originalButtonText) buttonText.textContent = originalButtonText;
      }
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
